import { Label } from '@presentation/components/molecules'

const PessoaIdentificacoesHead: React.FC = () => {
  return <Label tooltipText="Tipo - Matrícula - Situação">Identificações</Label>
}

export default PessoaIdentificacoesHead
